import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import toast from "react-hot-toast";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useStore from "../../features/store";
import apiClient from "../../services/apiClient";
import Loading from "../../components/common/loading";
import Input from "../../components/form/input";
import LoadingButton from "../../components/common/loadingButton";
import LockIcon from "../../assets/icons/lock.svg";

const schema = yup.object().shape({
  password: yup
    .string()
    .notRequired()
    .test(
      "is-valid-password",
      "رمز عبور باید حداقل ۸ کاراکتر باشد و شامل یک کاراکتر انگلیسی و یک کاراکتر ویژه باشد",
      (value) => {
        if (!value) return true;
        return (
          value.length >= 8 &&
          /[a-zA-Z]/.test(value) &&
          /[!@#$%^&*(),.?":{}|<>]/.test(value)
        );
      }
    ),
  repeat_password: yup
    .string()
    .notRequired()
    .oneOf([yup.ref("password"), null], "رمز عبور و تکرار آن باید یکسان باشند"),
});

const ProfilePassword = () => {
  //@ts-ignore
  const { profile, fetchProfile, isLoadingProfile } = useStore();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  async function updateUserProfile(profileData: any) {
    setLoading(true);

    try {
      const data = {
        password: profileData.password,
        repeat_password: profileData.repeat_password,
      };
      //@ts-ignore
      const response = await apiClient.patch("/profile", data);

      if (response.status === 200) {
        fetchProfile();
        setLoading(false);
        toast.success("رمز عبور با موفقیت تنظیم شد");
        navigate("/profile");
      }
    } catch (error) {
      setLoading(false);
      toast.error("مشکلی در ثبت اطلاعات پیش آمد");
      reset();
    }
  }

  const onSubmit = (data: any) => {
    updateUserProfile(data);
  };

  return (
    <div className="mt-10">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link to="/profile">پروفایل</Link>
          </li>
          <li className="font-[900]">تنظیم رمزعبور</li>
        </ul>
      </div>

      {isLoadingProfile ? (
        <div className="my-4 flex-1 w-full flex flex-col justify-between">
          <Loading type="profile" />
        </div>
      ) : (
        profile && (
          <Fade triggerOnce>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex-1 w-full max-w-lg mt-5 flex flex-col justify-between mb-10"
            >
              <div className="flex-1 mb-5">
                <Input
                  form={form}
                  errors={errors}
                  title="رمز عبور:"
                  icon={<img src={LockIcon} alt="رمز عبور" />}
                  id="password"
                  direction="ltr"
                  type="password"
                  info="رمز باید شامل حداقل ۸ عدد، حروف انگلیسی و یک کاراکتر خاص باشد."
                />

                <Input
                  form={form}
                  errors={errors}
                  title="تکرار رمز عبور:"
                  icon={<img src={LockIcon} alt="تکرار رمز عبور" />}
                  id="repeat_password"
                  direction="ltr"
                  type="password"
                />
              </div>

              <LoadingButton
                title="ثبت"
                type="submit"
                disabled={loading}
                loading={loading}
              />
            </form>
          </Fade>
        )
      )}
    </div>
  );
};

export default ProfilePassword;
